import { render, staticRenderFns } from "./directChannelConnection.vue?vue&type=template&id=ef15b17e&scoped=true&"
import script from "./directChannelConnection.vue?vue&type=script&lang=js&"
export * from "./directChannelConnection.vue?vue&type=script&lang=js&"
import style0 from "./directChannelConnection.vue?vue&type=style&index=0&id=ef15b17e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef15b17e",
  null
  
)

export default component.exports